import React from "react";
import {IconButton, TableCell, TableRow} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import IconGrn from "@material-ui/icons/AssignmentReturn";
import {useHistory} from "react-router-dom";
import IconDelete from "@material-ui/icons/Delete";
import {DEFAULT_DATE_FORMAT} from "../../common/Constants";
import IGrnDocument from "../../models/IGrnDocument";

interface IProps {
	document: IGrnDocument;
	onEdit: () => void;
	onDelete: () => void;
}

const IGrnDocumentsTableRow: React.FunctionComponent<IProps> = (props: IProps) => {
	const {document, onEdit, onDelete} = props;

	const history = useHistory();

	return (
		<TableRow>
			<TableCell>{document.documentNumber}</TableCell>
			<TableCell>{document.documentDate.format(DEFAULT_DATE_FORMAT)}</TableCell>
			<TableCell>{document.description}</TableCell>
			<TableCell style={{width: 152, textAlign: "center"}}>
				<IconButton size={"small"} onClick={() => history.push(`igrn_documents/${document.id}/items`)}>
					<IconGrn style={{transform: "scaleX(-1)"}}/>
				</IconButton>
				{
					document.acceptedAt.isEmpty && <>
						<IconButton size={"small"} onClick={onEdit}>
							<EditIcon/>
						</IconButton>
						<IconButton size={"small"} onClick={onDelete}>
							<IconDelete/>
						</IconButton>
					</>
				}
			</TableCell>
		</TableRow>
	);
};

export default IGrnDocumentsTableRow;